import { useContext, useMemo } from 'react';
import { ModelFiltersContext } from '../../ModelFiltersContext';
import { ModelFiltersKeys } from '../../ModelFiltersContext/constants';
import { PaymentMethod } from '../../../core/reducers/financialCalculators';
import { getAllTrimsFromModelData } from '../service/utils';
import { mapOffersToModelsWithPrice } from './utils';
var SPECIAL_RATE_OFFER_TYPES = [
    { id: ModelFiltersKeys.ALL_OFFERS, label: 'Pages.SpecialOffers.filterAllOffersLabel' },
    { id: PaymentMethod.lease, label: 'Pages.SpecialOffers.filterLeaseOffersLabel' },
    { id: PaymentMethod.finance, label: 'Pages.SpecialOffers.filterFinanceOffersLabel' },
    { id: PaymentMethod.cash, label: 'Pages.SpecialOffers.filterCashOffersLabel' },
];
var useSpecialOffersFilter = function (modelData) {
    var offersResponse = (useContext(ModelFiltersContext) || {}).offersResponse;
    var allTrims = getAllTrimsFromModelData(modelData);
    var allTrimsWithOffers = mapOffersToModelsWithPrice(allTrims, offersResponse.data);
    var availableSpecialOfferFilters = useMemo(function () {
        if (!(offersResponse === null || offersResponse === void 0 ? void 0 : offersResponse.isOffersSuccess))
            return [];
        var offerTypes = [PaymentMethod.lease, PaymentMethod.finance, PaymentMethod.cash];
        var offersAvailable = offerTypes.reduce(function (acc, type) {
            acc[type] = allTrimsWithOffers.some(function (_a) {
                var offersPresent = _a.offersPresent;
                return offersPresent === null || offersPresent === void 0 ? void 0 : offersPresent[type];
            });
            return acc;
        }, {});
        var availableCount = Object.values(offersAvailable).filter(Boolean).length;
        return SPECIAL_RATE_OFFER_TYPES.filter(function (_a) {
            var id = _a.id;
            return id in offersAvailable ? offersAvailable[id] : availableCount >= 2;
        });
    }, [offersResponse, allTrimsWithOffers]);
    return availableSpecialOfferFilters;
};
export default useSpecialOffersFilter;
